module.exports = __webpack_public_path__ + "static/media/exh3.231b4e19.png";